import { getApiUrl, getAuthHeaders } from './api-client';

export async function loginAdmin(credentials) {
  try {
    const apiUrl = getApiUrl();
    if (!apiUrl) return { error: true, message: 'API URL not configured' };

    const response = await fetch(`${apiUrl}/admin/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        login: credentials.email || credentials.login,
        password: credentials.password,
      }),
    });

    const data = await response.json();
    if (!response.ok) return { error: true, message: data.message || 'Login failed' };
    return data;
  } catch (error) {
    console.error('Error during admin login:', error);
    return { error: true, message: error.message };
  }
}

export async function getAdminMe() {
  try {
    const apiUrl = getApiUrl();
    if (!apiUrl) return null;

    const response = await fetch(`${apiUrl}/admin/auth/me`, {
      headers: { ...getAuthHeaders(), Accept: 'application/json' },
    });

    return response.ok ? response.json() : null;
  } catch (error) {
    console.error('Error fetching admin me:', error);
    return null;
  }
}
